const SloveniaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112369)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M38.756 13.0446H17.3913V7.82715H6.95648V13.0446H1.24398C0.440078 15.2111 0 17.5546 0 20.0011C0 22.4475 0.440078 24.7909 1.24398 26.9575L20 28.6967L38.756 26.9575C39.5599 24.7909 40 22.4475 40 20.0011C40 17.5546 39.5599 15.2111 38.756 13.0446Z"
        fill="#0052B4"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#D80027"
      />
      <path
        d="M6.95654 13.0424V14.7814C6.95654 18.7753 12.174 19.9989 12.174 19.9989C12.174 19.9989 17.3914 18.7753 17.3914 14.7814V13.0424L15.6522 14.7815L12.174 12.1729L8.69568 14.7815L6.95654 13.0424Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112369">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SloveniaSvg;
